import {HeaderTitle, Icon, LinkText} from '@/components/atoms'
import {useState} from 'react'
import {CustomDataTable, UploadHistoryTableModal} from '@/components/organisms'
import {getCellDataMappedCols} from '@/helpers/dataTableCellDataMapper'
import {Header} from '@/utils/constants/header'

import {useWarehouseTargets} from './useWarehouseTargets'
import {useWarehouseUploadHistory} from './useWarehouseHistory'

const cellDataMapperObj = {
  warehouseName: ({row: {original} = {}}) => {
    return (
      <div>
        <LinkText
          text={original?.warehouseName}
          id={original?.warehouseName + ' ' + original?.id}
          handleClick={() => {}}
        />
      </div>
    )
  },
}

/**
 * Column definitions for the sub-table
 */
const subColumns = [
  {
    columnKey: 'id',
    header: 'ID',
  },
  {
    columnKey: 'status',
    header: 'Status (REMARK)',
  },
]

/**
 * Column definitions for the main table
 */
const mainColumns = [
  {columnKey: 'file_path', header: 'FILE PATH'},
  {columnKey: 'import_date', header: 'IMPORT DATE'},
  {columnKey: 'job_start_date', header: 'JOB START DATE'},
  {columnKey: 'job_end_date', header: 'JOB END DATE'},
  {
    columnKey: 'total_records',
    header: 'STATISTICS',
    cellData: ctx => (
      <div className="flex flex-col">
        <div>{ctx.row.original.total_records}</div>
        {ctx.row.original.failed_records_count > 0 && (
          <div className={`failed-tests ${ctx.row.original.id}`} style={{color: 'red', fontWeight: 'bold'}}>
            {ctx.row.original.failed_records_count} Failed
          </div>
        )}
      </div>
    ),
  },
]

const WarehouseList = () => {
  const [rowSelected, setRowSelected] = useState([])
  const [pageIndex, setPageIndex] = useState(0)
  const [searchArray, setSearchArray] = useState([])
  const [sortConfig, setSortConfig] = useState({column: '', direction: 'desc'})
  const [isLoading, setIsLoading] = useState(false)

  const {warehouseTargetsData, warehouseTargetsColConfigData} = useWarehouseTargets()
  const cellDataMappedCols = getCellDataMappedCols(cellDataMapperObj, warehouseTargetsColConfigData)
  const {warehouseUploadHistoryData} = useWarehouseUploadHistory()

  const [openUploadHistory, setOpenUploadHistory] = useState(false)

  // Transform columns to CustomDataTable format
  const transformedColumns = warehouseTargetsColConfigData.map(col => {
    // Check if this column has a custom cell renderer
    const hasCustomRenderer = cellDataMapperObj[col.columnKey]

    return {
      name_of_db_column: col.columnKey,
      label_of_column: col.header,
      filterVariant: 'text', // You can customize this based on column type
      // If there's a custom renderer, we'll handle it differently
      ...(hasCustomRenderer && {customRenderer: cellDataMapperObj[col.columnKey]}),
    }
  })

  // Handle sorting
  const handleSorting = ({column, direction}) => {
    setSortConfig({column, direction})
    // Add your API call or data manipulation logic here
  }

  // Handle search/filter
  const handleSearchArray = searchObj => {
    if (Array.isArray(searchObj)) {
      setSearchArray(searchObj)
    } else {
      // Handle single search object
      setSearchArray(prev => {
        const filtered = prev.filter(item => item.field !== searchObj.field)
        return searchObj.value ? [...filtered, searchObj] : filtered
      })
    }
    // Add your API call or data manipulation logic here
  }

  // Handle row selection
  const handleRowSelect = (selectedRows, isSelectAll) => {
    setRowSelected(selectedRows)
  }

  // Handle reset all
  const handleResetAll = () => {
    setSearchArray([])
    setSortConfig({column: '', direction: 'desc'})
    setPageIndex(0)
    // Add any additional reset logic
  }

  // Handle download
  const handleDownload = () => {
    alert('Download')
    // Add your download logic here
  }

  return (
    <div className="warehouseTargetsDataTable">
      <div className="relative" style={{backgroundColor: '#1D1D1D'}}>
        <HeaderTitle
          headingLevel={Header.SectionTitle}
          title="Warehouse List"
          className="warehouseDataTableHeading  pl-4 pr-4"
        />
        <span className="warehouseSettingsIcon absolute h-8 w-8 rounded p-2">
          <Icon icon="settings" isDark={true} size="small" className="h-4 w-4" />
        </span>

        {/* View Upload History Button */}
        <div style={{display: 'flex', justifyContent: 'flex-end', padding: '10px'}}>
          <button
            onClick={() => setOpenUploadHistory(true)}
            style={{
              backgroundColor: 'transparent',
              color: '#3387DF',
              border: '1px solid #3387DF',
              borderRadius: '60px',
              padding: '8px 16px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold',
            }}
          >
            View Upload History
          </button>
        </div>

        {warehouseTargetsData?.data?.length > 0 && transformedColumns.length > 0 && (
          <CustomDataTable
            columns={transformedColumns}
            records={[]}
            isLoading={isLoading}
            pageSize={10}
            totalRecords={warehouseTargetsData?.totalRecords || 0}
            setPageIndex={setPageIndex}
            handleSorting={handleSorting}
            setSearchArry={handleSearchArray}
            onResetAll={handleResetAll}
            onRowSelect={handleRowSelect}
            onDownload={handleDownload}
            showDownload={true}
            isSelectAll={false}
          />
        )}
        {/* {warehouseTargetsData?.totalRecords && (
          <div className="txtRightAlign">{warehouseTargetsData?.totalRecords} total items</div>
        )} */}
      </div>

      <UploadHistoryTableModal
        openUploadHistory={openUploadHistory}
        setOpenUploadHistory={setOpenUploadHistory}
        mainData={warehouseUploadHistoryData}
        mainColumns={mainColumns}
        subData={(warehouseUploadHistoryData || [])?.flatMap(
          item =>
            item?.failed_records?.map(record => ({
              ...record,
              parentId: item?.id,
            })) || []
        )}
        subColumns={subColumns}
        isDark={true}
      />
    </div>
  )
}

export default WarehouseList
